import React from 'react';
import PropTypes from 'prop-types';
import Icon from 'components/Icon';
import { noop } from 'helpers/GlobalHelper';

const MobilePlayButton = ({ theme, text, render, link = null, playButtonClick = noop }) => {
  if (!render) return null;
  return (
    <div className={theme.play}>
      <div
        aria-label="play button"
        onMouseDown={e => (e.button === 1 ? playButtonClick() : noop)}
        onClick={playButtonClick}
      >
        <Icon icon="play-button" color="white" size="full" />
        {text && <div className={theme.playText}>{text}</div>}
      </div>
    </div>
  );
};

MobilePlayButton.propTypes = {
  link: PropTypes.string,
  playButtonClick: PropTypes.func,
  render: PropTypes.bool,
  text: PropTypes.string,
  theme: PropTypes.shape({}),
};

export default MobilePlayButton;
